import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicResidentBg({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 16 16"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <path
        d="M6.81 3.58a.3.3 0 01.38 0l4.2 3.46A5 5 0 007 12v.05H2.72a.39.39 0 01-.38-.31V7.28zM12 16a4 4 0 100-8 4 4 0 000 8zm1.52-5.79a.38.38 0 01.54 0l.33.33c.15.15.15.39 0 .54l-2.71 2.71a.38.38 0 01-.54 0l-1.53-1.53a.38.38 0 010-.54l.33-.33a.38.38 0 01.54 0l.93.93 2.11-2.1zm-1.66-6.05V.79a.3.3 0 00-.3-.29h-1.35a.3.3 0 00-.3.3v1.76L7.75.76a1.17 1.17 0 00-1.48 0L.1 5.84a.3.3 0 00-.04.41L.69 7a.3.3 0 00.4.04l5.72-4.71a.3.3 0 01.38 0l5.71 4.7a.3.3 0 00.41-.03l.62-.76a.3.3 0 00-.04-.4l-2.03-1.68z"
        fill="#F4F5FB"
        fillRule="evenodd"
      />
    </svg>
  );
}

SvgPicResidentBg.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicResidentBg.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => <SvgPicResidentBg svgRef={ref} {...props} />);
export default ForwardRef;
